import React, { Component } from 'react'
import { truncate } from 'lodash'
import formatCurrencyToBr from 'format-currency-to-br'
import StarRating from './../Modal/ModalItem/components/StarRating'
import NewSchoolAdoptionContainer from './../../containers/NewSchoolAdoptionContainer'
import favoriteSeal from '../../static/images/favorite.png'

import './bookitem.css'

class BookItem extends Component {
  render () {
    const { item, handleOpenModal } = this.props
    const {book} = item
    const joinedAuthorName = book.authors.map(author => author.name).join(', ')
    const authorNames = truncate(joinedAuthorName, {
      length: 48,
      separator: /,? +/
    })

    return (
      <li className='product-item'>
        <div className='product-item__container'>
          <h4 className='product-item__title'>
            {
              truncate(book.name, {
                length: 65,
                separator: /,? +/
              })
            }
          </h4>
          <div className='product-item__body'>
            <div className='product-item__image-container'>
              <img src={book.photo.url || `${process.env.PUBLIC_URL}/img/default_pic.png`} alt={`Capa do livro: ${book.name}`} />
            </div>
            <div className='product-item__container-txt'>
              <div>
                <div className='product-item__authors_row'>
                  <div>
                    <p className='product-item__subtitle'>
                      {authorNames}
                    </p>
                    <div className='product-item__rating'>
                      <StarRating rating={book.average} />
                    </div>
                  </div>
                  { item.favorite ? <div><img src={favoriteSeal} alt='Este livro é um destaque' /></div> : ''}
                  
                </div>
                <div className='product-item__publisher'>
                  <span className='product-item__publisher__label'>I.S.B.N.:</span>
                  <span className='product-item__publisher__title'>{book.isbn}</span>
                </div>
                <div className='product-item__publisher'>
                  <span className='product-item__publisher__label'>Editora:</span>
                  <span className='product-item__publisher__title'>{book.publisher.name}</span>
                </div>
              </div>
              <div className='product-item__price'>
                <span className='product-item__price__label'>Preço:</span>
                <span className='product-item__price__title'>{formatCurrencyToBr(item.value)}</span>
              </div>
            </div>
          </div>
          <div className='product-item__detail'>
            <button onClick={() => handleOpenModal(book.id, item)} className='button is-primary'>Ver mais</button>
          </div>
          <div className='product-item__action'>
            <NewSchoolAdoptionContainer bookId={book.id} gradeId={this.props.gradeId} />
          </div>
        </div>
      </li>
    )
  }
}

export default BookItem



// WEBPACK FOOTER //
// ./src/components/BookItem/index.js